import { useState } from 'react';
import { observer } from 'mobx-react-lite';

import currentAccountStore from '../../../../pages/accounts/stores/current-account-store';
import FileUpload, { FILE_UPLOAD_VARIANTS } from '../../../../components/file-upload/file-upload';
import { Button } from '../../../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../../../components/inputs/button-variants';
import FontBody2 from '../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../components/fonts/font-props';
import IconFile from '../../../../components/icons/icon-file/icon-file';
import { ConfirmModal } from '../../../../components/modal/components/confirm-modal/confirm-modal';
import CurrentPortalStore from '../../../../stores/current-portal-store';

import TroubleshootingStore from '../../troubleshooting-page-store';

import './translations-page.scss';

const TranslationsPage: React.FC = observer(() => {
    const [translationsFile, setTranslationsFile] = useState<{ fileData: File, fileContent: string } | null>(null);
    const [isUploadConfirmed, setIsUploadConfirmed] = useState<boolean>(false);

    const isSysAdmin = currentAccountStore.isSysAdmin;
    const portalId = CurrentPortalStore.currentPortal.id;

    if (!isSysAdmin || portalId) {
        return (
            <div className="translations-page">
                <div className="card">
                    <h4>Admin Translations</h4>
                    <FontBody2 color={FONT_COLOR.NEUTRAL10}>
                        Admin translations management is only available for specified system administrators.
                    </FontBody2>
                </div>
            </div>
        );
    }

    const confirmUploadTranslations = () => {
        if (translationsFile) {
            TroubleshootingStore.uploadTranslationsFile(translationsFile.fileData, translationsFile.fileContent);
            setIsUploadConfirmed(false);
            setTranslationsFile(null);
        }
    };

    return (
        <div className="translations-page">
            <div className="card">
                <h4>Admin Translations</h4>
                <div className="buttons_container">
                    <div>
                        <div>
                            <FontBody2 color={FONT_COLOR.NEUTRAL3}>{"Required file format: .csv"}</FontBody2>
                        </div>
                        <FileUpload
                            readType="text"
                            fileTypes={["text/csv"]}
                            acceptedFileFormats="csv"
                            uploadFile={(fileData, fileContent) => {
                                setTranslationsFile({ fileData, fileContent: fileContent as string });
                                setIsUploadConfirmed(true);
                            }}
                            buttonText={"UPLOAD FILE"}
                            variant={FILE_UPLOAD_VARIANTS.Secondary}
                            disabled={TroubleshootingStore.isDownloading() || TroubleshootingStore.isUploading()}
                        />
                    </div>
                    <div>
                        <Button
                            text="Download File"
                            variant={BUTTON_VARIANTS.Secondary}
                            leftIcon={IconFile}
                            onClick={() => TroubleshootingStore.downloadTranslations()}
                            isLoading={TroubleshootingStore.isDownloading()}
                            hasLoader={true}
                            disabled={TroubleshootingStore.isDownloading() || TroubleshootingStore.isUploading()}
                        />
                    </div>
                </div>
                {TroubleshootingStore.isUploading() ? (
                    <FontBody2 color={FONT_COLOR.ACCENT1} variant={[FONT_VARIANT.DEFAULT, FONT_VARIANT.DEFAULT]}>
                        File is processing...
                    </FontBody2>
                ) : null}
                {TroubleshootingStore.uploadedSuccessfuly() ? (
                    <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>
                        Admin translations uploaded successfully!
                    </FontBody2>
                ) : null}
            </div>

            {isUploadConfirmed ? (
                <ConfirmModal
                    title={"Upload Admin Translations"}
                    text=""
                    implicationText={<>Note: this action will take place for <strong>all merchants</strong>.</>}
                    questionText={"Are you sure you want to update the admin translations?"}
                    cancelButton={{
                        title: "Cancel",
                        onClick: () => setIsUploadConfirmed(false)
                    }}
                    okButton={{
                        title: "Confirm",
                        onClick: confirmUploadTranslations
                    }}
                />
            ) : null}
        </div>
    );
});

export default TranslationsPage;

